export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getAreaUnitList: function getAreaUnitList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/area_unit/get",
        method: "get",
        params: data
      });
    },
    addAreaUnit: function addAreaUnit() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/area_unit/add",
        method: "post",
        data: data
      });
    },
    updateAreaUnit: function updateAreaUnit() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/area_unit/update",
        method: "post",
        data: data
      });
    }
  };
});